<app-text class="is-family-bold is-size-3">
  <ng-content></ng-content>
</app-text>